// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"64778097","202":"f43fd312"}[chunkId] + ".chunk.js";
};